import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMode, AppMode } from "../context/ModeContext";
import BrandLogo from "../components/BrandLogo";

const Signup: React.FC = () => {
  const { register } = useAuth();
  const { setMode } = useMode();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState<AppMode>("thrower");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(email, password);
      setMode(role);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page auth-page">
      <form className="form" onSubmit={handleSubmit}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.25rem" }}>
          <BrandLogo variant="mark" />
        </div>
        <h1>Create Account</h1>
        <p className="form-hint">
          Choose how you want to start. You can build a Goer profile anytime.
        </p>

        {error && <div className="error-message inline">{error}</div>}

        <div className="form-group">
          <label>I am here to…</label>
          <div className="mode-toggle role-select" role="group" aria-label="Account role">
            <button
              type="button"
              className={role === "thrower" ? "active" : ""}
              onClick={() => setRole("thrower")}
            >
              Throw a wedding
            </button>
            <button
              type="button"
              className={role === "goer" ? "active" : ""}
              onClick={() => setRole("goer")}
            >
              Attend as a Goer
            </button>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            minLength={6}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Creating account..." : "Sign Up"}
        </button>

        <p className="auth-switch">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default Signup;
